module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAtCAYAAAAtOHJTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQ9JREFUeNrM2c0NwjAMBeDU4tQTIzACI8AIbMAmjMQIXYFN4JQruJU4oNK/5Nl+lqJcoupTXDdWkxIgcs7HxBqKe9ICFfa2AArwWXsdHRIo4E2EAsUgyzCgGL2GEKAY1kk1UIwLuQpojasCeuCKgV64IqAnbjNwpwuvOh8CgOe2bR9zCxtd1Ol8CjiSXzpmgZLiYjHFkbhFYDRuFsiAmwSy4P4CmXAjIBvuB8iI+wLvrLj+A30RUthwcggrjK0gRmetsMJYcJPdibDConGL/VwD6oRvaNiAQ2xB/5cJDYtI62qYN24TzBO3GeaFK4J54Iph1rgqmCWuGmaFg8AscDAYLKzuIVA46hscE9hHgAEAXXap4wk+WYUAAAAASUVORK5CYII="


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/next.png
 ** module id = 172
 ** module chunks = 0
 **/